<template>
  <div id="app">
 
    <MainPage/>
  </div>
</template>

<script>
import MainPage from './components/MainPage'

export default {
  name: 'App',
  components: {
    MainPage
  }
}
</script>

<style>
body{
   font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}
#app {
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 70px;
  text-align: center;
 
}

.footer {
  height: 60px;
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background: #0078e7;

   color: white;
   font-weight: 700;
   padding-left: 10px;
   font-size: 13px;

}
</style>



// WEBPACK FOOTER //
// src/App.vue